import MyInput from '../../components/ui/MyInput';
import deleteX from '../../assets/img/deleteX.svg';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import {
  SVG_Add_Square_Bold,
  SVG_Traffic_Bold,
  SVG_Trash_Bin_2_Bold,
  SVG_Trash_Bin_2_Linear,
  SVG_Trash_Bin_2_Outline,
  SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { useNavigate } from 'react-router-dom';
import allTabs from '../DashboardTabs';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import CreateAction from '../../components/operational/createAction';
import useCustomNavigate from '../../components/operational/goBack';
const Policies = ({ tab }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const goBack = useCustomNavigate(tab);
  const [policies, setPolicies] = useState([]);
  const [policyName, setPolicyName] = useState('');
  const [policyURL, setPolicyURL] = useState('');

  const handleAddPolicy = () => {
    if (!policyName) {
      dispatch(systemSlice.actions.setToastError({ detail: 'Sözleşme adı boş olamaz.' }));

      return;
    }
    if (!policyURL) {
      dispatch(systemSlice.actions.setToastError({ detail: 'Sözleşme URL boş olamaz.' }));
      return;
    }
    const newPolicy = {
      title: policyName,
      link: policyURL,
    };

    setPolicies([...policies, newPolicy]);
    setPolicyName('');
    setPolicyURL('');
  };

  const handlePolicyNameChange = (index, value) => {
    const updatedPolicies = [...policies];
    updatedPolicies[index].title = value;
    setPolicies(updatedPolicies);
  };

  const handlePolicyURLChange = (index, value) => {
    const updatedPolicies = [...policies];
    updatedPolicies[index].link = value;
    setPolicies(updatedPolicies);
  };

  const handleDeletePolicy = index => {
    const updatedPolicies = [...policies];
    updatedPolicies.splice(index, 1);
    setPolicies(updatedPolicies);
  };

  const getPolicies = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/policies`,
      showPreLoader: true,
      isFileUploading: false,
    });

    if (response?.error) {
      return navigate('/dashboard/');
    }

    const fetchedPolicies = response?.result?.resultData.tr || [];

    // Eğer fetchedPolicies varsa, bunları yükle
    if (fetchedPolicies.length > 0) {
      setPolicies(fetchedPolicies);
    } else {
      // Başlangıç poliçeleri
      setPolicies([
        { title: 'Gizlilik', link: '' },
        { title: 'Mesafeli', link: '' },
        { title: 'İade', link: '' },
        { title: 'KVKK', link: '' },
      ]);
    }
  };

  const savePolicies = async () => {
    const response = await CreateAction({
      method: 'patch',
      path: `/policies`,
      showPreLoader: true,
      isFileUploading: false,
      data: { tr: policies },
    });
    if (response.error) return;
    goBack();
  };
  useEffect(() => {
    const fetchPolicies = async () => {
      await getPolicies();
    };

    fetchPolicies();
  }, []);

  return (
    <>
      <LayeredDashboardHeader tab={tab} onSave={savePolicies}></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto">
            <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%]">
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="text-[#5E5873] text-[18px] font-semibold">Ayarlar</div>
                </div>
              </div>
              <div className="mt-[40px]">
                <div className="text-[#5E5873] block mb-[5px] text-[14px] font-semibold">Sözleşmeler</div>
                <div className="text-[#8A92A6] block mb-[5px] text-[14px] font-medium">
                  Lütfen sahip olduğunuz sözleşmeleri ekleyiniz.
                </div>
                <div className="flex gap-[20px] flex-col justify-start">
                  <div className="grid clearLabel grid-cols-1 lg:grid-cols-2 gap-[40px]">
                    <div>
                      <input
                        placeholder="Sözleşme Adı"
                        isRequired={true}
                        value={policyName}
                        onChange={e => {
                          setPolicyName(e.target.value);
                        }}
                        className="bg-white border h-[45px] text-gray-900 text-sm rounded-[5px]
                    border-[#E3E8EF]  focus:outline-none focus:ring-[#7059EF] focus:border-[#7059EF] block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 border-slate-300 py-[30px] px-[25px]"
                      />
                    </div>
                    <div>
                      <input
                        placeholder="Sözleşme URL"
                        isRequired={true}
                        value={policyURL}
                        onChange={e => {
                          setPolicyURL(e.target.value);
                        }}
                        className="bg-white border h-[45px] text-gray-900 text-sm rounded-[5px]
                    border-[#E3E8EF]  focus:outline-none focus:ring-[#7059EF] focus:border-[#7059EF] block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 border-slate-300 py-[30px] px-[25px]"
                      />
                    </div>
                  </div>
                  <div className="flex justify-center">
                    <PrimaryButton
                      onClick={() => handleAddPolicy()}
                      value={
                        <>
                          <SVG_Add_Square_Bold className={'fill-white'}></SVG_Add_Square_Bold>
                          Sözleşme Ekle
                        </>
                      }
                    />
                  </div>
                </div>
                <div>
                  {policies?.map((policy, index) => (
                    <div key={index} style={{ marginTop: '20px' }}>
                      <div
                        style={{
                          display: 'flex',
                          alignContent: 'center',
                          alignItems: 'center',
                          gap: '40px',
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <input
                            placeholder="Sözleşme Adı"
                            isRequired={true}
                            value={policy.title}
                            onChange={e => handlePolicyNameChange(index, e.target.value)}
                            className="bg-white border h-[45px] text-gray-900 text-sm rounded-[5px]
            border-[#E3E8EF]  focus:outline-none focus:ring-[#7059EF] focus:border-[#7059EF] block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 border-slate-300 py-[30px] px-[25px]"
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <input
                            placeholder="Sözleşme URL"
                            isRequired={true}
                            value={policy.link}
                            onChange={e => handlePolicyURLChange(index, e.target.value)}
                            className="bg-white border h-[45px] text-gray-900 text-sm rounded-[5px]
            border-[#E3E8EF]  focus:outline-none focus:ring-[#7059EF] focus:border-[#7059EF] block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 border-slate-300 py-[30px] px-[25px]"
                          />
                        </div>
                        <button onClick={() => handleDeletePolicy(index)}>
                          <SVG_Trash_Bin_2_Linear
                            className={'stroke-[#E23D47] fill-[#E23D47]'}
                          ></SVG_Trash_Bin_2_Linear>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Policies;
